(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Press-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.custom-slick-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: false,
    arrows: true,
    dots: false,
    prevArrow: $('.custom-arrow.left'),
    nextArrow: $('.custom-arrow.right')
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.slick-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: false,
    arrows: true,
    dots: false,
    prevArrow: $('.gallery-arrow.left'),
    nextArrow: $('.gallery-arrow.right')
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-process"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.process-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: false,
    arrows: true,
    dots: false,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>'
  });
});

  } catch(e) { console.error(e); }
})();
})();
